<template>
  <div class="ibox">
    <div class="ibox-title">
      TOKEN DE API
    </div>
    <div class="ibox-content">
      <p class="mb-2">
        Envie este token no header <strong>token</strong> das requisições da API.
      </p>

      <div class="d-flex align-items-center mb-2">
        <span class="mr-3">● ● ● ● ● ● ● ● ● ● ● ● ● ● ●</span>

        <CopyIcon
          v-if="apiToken"
          @click="copy"
          class="fd-icon mr-4"
          size="1.2x"
          style="cursor: pointer"
          v-tooltip.bottom="{ content: tooltip }"
        />

        <button class="btn btn-outline btn-sm" @click="renew">Gerar novo token</button>
      </div>

      <small>Gerar um novo token invalida o atual na hora, para todas as integrações que o usam.</small>
    </div>
  </div>
</template>

<script>
  import GetUser from '@/mixins/GetUser'
  import GlobalLoading from '@/mixins/GlobalLoading'
  import User from '@/models/User'
  import { CopyIcon } from 'vue-feather-icons'

  export default {
    components: { CopyIcon },
    created() {
      this.load()
    },
    data() {
      return {
        accountUser: {},
        tooltip: 'Clique para copiar'
      }
    },
    computed: {
      apiToken() {
        return this.accountUser.apiToken
      }
    },
    methods: {
      load() {
        const params = { includes: ['account_user'] }

        this.axios.get(`users/${this.getUser.id}`, { params })
          .then(response => this.accountUser = User.build(response.data).accountUser || {})
          .catch(e => this.$notify.addError(e))
      },
      copy() {
        navigator.clipboard.writeText(this.apiToken)
          .then(() => {
            this.tooltip = 'Token copiado!'
            setTimeout(() => this.tooltip = 'Clique para copiar', 2000)
          })
          .catch(() => this.$notify.addError('Erro ao copiar o token'))
      },
      renew() {
        if (!confirm('Gerar um novo token?\nO token atual deixa de funcionar imediatamente.'))
          return

        this.openGlobalLoad()
        this.axios.put(`/account_users/${this.accountUser.id}/renew_token`)
          .then(response => this.accountUser.apiToken = response.data.api_token)
          .then(() => this.$notify.add('Novo token gerado'))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      }
    },
    mixins: [GetUser, GlobalLoading],
    name: 'ApiToken'
  }
</script>

<style scoped>
</style>
